"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  VectorMap: () => VectorMap
});
module.exports = __toCommonJS(src_exports);

// lib/react-shim.js
var React = __toESM(require("react"));

// src/VectorMap.tsx
var import_jsx_runtime = require("react/jsx-runtime");
function VectorMap({
  id,
  name,
  layers,
  tabIndex = 0,
  layerProps,
  checkedLayers,
  currentLayers,
  children,
  ...other
}) {
  if (!layers || layers.length === 0) {
    console.error(
      `[@south-paw/react-vector-maps] No 'layers' prop provided. Did you spread a map object onto the component?`
    );
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": name,
    ...other,
    children: [
      children,
      layers.map((layer) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", {
        tabIndex,
        "aria-label": layer.name,
        "aria-checked": checkedLayers && checkedLayers.includes(layer.id),
        "aria-current": currentLayers && currentLayers.includes(layer.id),
        ...layer,
        ...layerProps
      }, layer.id))
    ]
  }, id);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  VectorMap
});
//# sourceMappingURL=index.js.map